import { useEffect, useState } from 'react';
import getAwardCards from './getAwardCards';
import { useSelector } from 'react-redux';

export const useAwardsCards = (currentUser, navigate, searchParams) => {
    const [awardCards, setAwardCards] = useState(null);

    const authInfoLoaded = useSelector(s => s.Auth.authInfoLoaded);
    const authInProgress = useSelector(s => s.Auth.authInProgress);

    const showAwardCards = authInfoLoaded && !authInProgress;

    useEffect(() => {
        if (!showAwardCards) return;

        const allCards = getAwardCards(currentUser, navigate, searchParams).filter(
            ({ show }) => show
        );

        setAwardCards(allCards);
    }, [showAwardCards]);

    return awardCards;
};
